import { NgModule } from '@angular/core';

import { LazyImageLoadingDirective } from './lazy-image.directive';

@NgModule({
	declarations: [LazyImageLoadingDirective],
	exports: [LazyImageLoadingDirective],
})
export class LazyImageLoadingModule {}
